var $ = require('jquery');
var _ = require('lodash');

// Keep in sync with ../css/_grid-settings.scss !
var getWidth = function () {
    // See http://stackoverflow.com/a/8876069
    return Math.max(document.documentElement.clientWidth,
                    window.innerWidth || 0);
};

var width1 = function (op) {
    return function (width) {
        return op(getWidth(), width);
    };
};

module.exports = {
    width: getWidth,
    lte: width1(function (a, b) { return a <= b; }),
    gte: width1(function (a, b) { return a >= b; })
};



//////////////////
// WEBPACK FOOTER
// /srv/mestis/mestis.git/liiga/static/liiga/common/js/breakpoint.js
// module id = 7
// module chunks = 0